<script lang="ts">
  import { HEAD } from '@centerhealth/fe/center-kit';

  export let htmlHead: HEAD;

  let title: string;
  let host: string;
  let description: string;
  let url: string;

  $: ({ title, description, url, host } = htmlHead);
</script>

<!-- This is a utility component -->
<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <!-- Facebook/OpenGraph meta -->
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:url" content={url} />
  <meta property="og:image" content={`${host}/assets/social/share-widget-card-nano.webp`} />
  <meta property="og:type" content="website" />
  <meta property="fb:app_id" content="1608343475878228" />
  <!-- Twitter meta -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:site" content="@centerhealth_" />
  <meta name="twitter:image" content={`${host}/assets/social/share-widget-card-nano.webp`} />
  <!-- We can add more custom ones using slot composition -->
  <slot />
</svelte:head>
